import { GetStaticProps } from "next";

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      pageOgTitle: "장례, 어디서부터 시작해야 할까요?  - [우리가 찾던 장례전문가, 고이]",
      pageDescription:
        "어떤 기준으로 알아봐야 할까요? 어떤 곳이 믿을만하고, 장례를 맡길 수 있을까요?",
      pageKeywords:
        "후불제, 후불제상조, 선불제, 선불제상조, 후불제상조 선불제상조, 장례, 장례상담, 상조, 상조순위, 상조 기준, 상조차이, 상조비교, 상조회사, 상조회사서비스, 보람상조, 프리드라이프, 예다함",
      pageOgDescription:
        "가격 얘기부터 시작하여 부담만 주는 상담원. 장례식장에 전화만 하면 한번에 해결된다고 알려주는 지인. 지나치게 많은 상조 회사에, 넘치는 광고글. 많이 알아볼수록 혼란스럽기만 해요. 어떤 기준으로 알아봐야 할까요? 어떤 곳이 믿을만하고, 장례를 맡길 수 있을까요?",
      pageOgImage: `${process.env.NEXT_PUBLIC_CDN_URL}/platform/prepare/prepare-1-1.png`,
    },
  };
};

export { PrepareFirstContainer as default } from "containers/FuneralPrepareContainer";
